import React from 'react';
import PropTypes from 'prop-types';
var UserLocationMarker = function UserLocationMarker() {
  return /*#__PURE__*/React.createElement("div", {
    className: "user-location-marker"
  });
};
var SearchLocationMarker = function SearchLocationMarker() {
  return /*#__PURE__*/React.createElement("div", {
    className: "search-location-marker"
  });
};
var GoogleMapMarker = function GoogleMapMarker(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "location-marker ".concat(props.selectedClass),
    onClick: props.onClick,
    role: "presentation"
  });
};
var GoogleClusterMarker = function GoogleClusterMarker(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "location-cluster-marker ".concat(props.points.length === 2 ? 'small' : 'big'),
    onClick: props.onClick,
    role: "presentation"
  }, /*#__PURE__*/React.createElement("div", {
    className: "counter"
  }, props.points.length));
};
export { UserLocationMarker, SearchLocationMarker, GoogleMapMarker, GoogleClusterMarker };
GoogleMapMarker.propTypes = {
  selectedClass: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};
GoogleClusterMarker.propTypes = {
  points: PropTypes.arrayOf(PropTypes.any).isRequired,
  onClick: PropTypes.func.isRequired
};